import { useNavigation } from "react-router";

import "@scss/navigationProgress.scss";

// Thin bar across the top while the router loads the next page's code. The
// current page stays on screen meanwhile, so this is the only sign a click
// registered.
export default function NavigationProgress() {
  const { state } = useNavigation();

  if (state === "idle") {
    return null;
  }

  return (
    <div
      className="navigation-progress"
      role="progressbar"
      aria-label="Loading page"
    >
      <div className="navigation-progress__bar" />
    </div>
  );
}
